import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vittaa-branding',
  templateUrl: './vittaa-branding.component.html',
  styleUrls: ['./vittaa-branding.component.scss']
})
export class VittaaBrandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
